module.exports = __webpack_public_path__ + "static/img/5.f3bd2578.jpg";